import React from 'react';
import { Container } from '../components/ui/Primitives';
import { Button } from '../components/ui/Button';
export function NotFound() {
  return <Container className="py-24 text-center sm:py-32" data-id="element-848" data-mp="w4jbd3p42kbi">
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-849" data-mp="105lcjq2l96g4">Page not found</p>
      <h1 className="mt-4 font-display text-[34px] leading-tight text-ink sm:text-[44px]" data-id="element-850" data-mp="1557ozxaleinv">
        We cannot find that page
      </h1>
      <p className="mx-auto mt-5 max-w-md text-[16px] text-body" data-id="element-851" data-mp="1a3sg977v9s06">
        The link may be out of date. Our services, insights and resources are all reachable from the main
        navigation.
      </p>
      <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-852" data-mp="1jund15iqo9zv">
        <Button to="/" data-id="element-853" data-mp="1nu5ozbsl1aqk">Back to the home page</Button>
        <Button to="/insights" variant="secondary" data-id="element-854" data-mp="1sujuam2su6kw">Read our insights</Button>
      </div>
    </Container>;
}